import React from 'react'

interface CircleDownProps {
    size?: number
    color?: string
}

const CircleDown: React.FC<CircleDownProps> = ({ size = 24, color }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-labelledby="dropdownArrowTitle" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title id="dropdownArrowTitle">Dropdown arrow icon</title>
            <circle cx="12" cy="12" r="10" fill="none" />
            <path d="M12 17L10.59 15.59L12 13.76L13.41 15.59L12 17Z" fill={color ?? '#000'} />
        </svg>
    )
}

export default CircleDown
